import * as St from './Design.styles';

import { useDrawingShapeContext } from '~contexts';
import CornerRadiusConstraintModal from '~organisms/CornerRadiusConstraintModal';
import DesignSidePanel from '~organisms/DesignSidePanel';

type DesignProps = React.PropsWithChildren<{
  isSidePanelExpanded?: boolean;
}>;

const Design = ({ children, isSidePanelExpanded = true }: DesignProps) => {
  const {
    getters: { isCornerRadiusConstraintModalOpen },
    handlers: { setIsCornerRadiusConstraintModalOpen },
  } = useDrawingShapeContext();

  return (
    <>
      <CornerRadiusConstraintModal
        isOpen={isCornerRadiusConstraintModalOpen}
        onClose={() => setIsCornerRadiusConstraintModalOpen(false)}
      />
      <St.Container>
        <St.DrawingAreaContainer>{children}</St.DrawingAreaContainer>
        <DesignSidePanel isExpanded={isSidePanelExpanded} />
      </St.Container>
    </>
  );
};

export default Design;
